import { Component, Input } from "@angular/core";
import { ILeverageTokenInfoSummaryViewModel } from "@modules/main/components/leveraged-tokens/leverage-token-info-summary/leverage-token-info-summary.interface";
import { LeveragedTokenType } from "@modules/main/components/leveraged-tokens/leveraged-token-toggle/leveraged-token-type.model";
import { LEVERAGED_TOKEN_LONG_ICON_VALUE, LEVERAGED_TOKEN_SHORT_ICON_VALUE } from "@helpers/constants";

@Component({
	selector: "leveraged-token-info-amount",
	templateUrl: "./leveraged-token-info-amount.component.html",
	styleUrls: ["./leveraged-token-info-amount.component.scss"],
	standalone: false
})
export class LeveragedTokenInfoAmountComponent {
	public type = LeveragedTokenType;
	@Input() public vm: ILeverageTokenInfoSummaryViewModel = undefined;
	@Input() public amountInput: number;
	@Input() public cfdEnabled: boolean;
	protected readonly LEVERAGED_TOKEN_LONG_ICON_VALUE = LEVERAGED_TOKEN_LONG_ICON_VALUE;
	protected readonly LEVERAGED_TOKEN_SHORT_ICON_VALUE = LEVERAGED_TOKEN_SHORT_ICON_VALUE;
}
